import { FC, useMemo } from 'react';
import { useGetCurrentUserQuery } from '@teachur/http-client';
import { useDegreePageContext } from '../../contexts/DegreePageContext';
import { CourseList } from '@new/common/components/Course/CourseList';
import { CourseListHeader } from './CourseListHeader';
import { DegreeInfoBanner } from './DegreeInfoBanner';
import { useAbility } from '@new/casl';

// TEMPORARY: external reviewer accounts (e.g. DEAC accreditation) that are
// allowed to see non-public courses inside a degree they've been enrolled in,
// so they can review an unpublished program without it becoming public.
// Remove once a proper read-only reviewer role exists. Matched case-insensitively.
const REVIEWER_EMAILS = ['deac-2026-mala@newlane.edu'];

export const DegreeCourseList: FC = () => {
  const { courses, degreeId } = useDegreePageContext();
  const ability = useAbility();
  const { data: currentUser } = useGetCurrentUserQuery();

  const coursesArray = useMemo(() => {
    const isReviewer =
      !!currentUser?.email && REVIEWER_EMAILS.includes(currentUser.email.toLowerCase());

    // Admins and whitelisted reviewers see every course regardless of
    // visibility; everyone else sees only public courses.
    if (ability.can('access', 'AdminPanel') || isReviewer) {
      return courses.all;
    }

    return courses.all.filter((course) => course.visibility === 'public');
  }, [courses, ability, currentUser]);

  const shouldShowBanner = courses.inProgress.length === 0 && courses.completed.length === 0;

  return (
    <CourseList
      courses={coursesArray}
      degreeId={degreeId}
      header={<CourseListHeader />}
      showBanner={shouldShowBanner}
      banner={<DegreeInfoBanner />}
      readOnly
    />
  );
};
